import store from "../../store/index";
import customModal from "../customModal/customModal.vue";

export default {
  name: "CriticalDPModal",
  props: {
    criticalInfo: {
      type: Object,
      default: () => ({}),
    },
    formPage: {
      type: String,
      default: "",
    }
  },
  components: { customModal },
  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      idToken: store.getters.getIdToken,
      headerValues: {},
    };
  },
  mounted() {
    console.log("Critical Info:", this.criticalInfo);
  },
  methods: {
    closeModal() {
      this.$emit("closeModal");
    },
  },
};